import { cva, type VariantProps } from 'class-variance-authority'
import React, { HTMLAttributes } from 'react'
import { cn } from './cn'

export const chipVariants = cva(
  'inline-flex items-center gap-1 whitespace-nowrap rounded-xs px-2 py-0.5 font-text text-[12px] leading-[1.4] font-medium tracking-[0.01em]',
  {
    variants: {
      tone: {
        neutral: 'bg-surface-2 text-fg-2',
        accent: 'bg-chip text-accent',
        success: 'bg-success-bg text-success',
        info: 'bg-info-bg text-info',
        pending: 'bg-warning-bg text-warning',
        danger: 'bg-danger-bg text-danger',
      },
    },
    defaultVariants: { tone: 'neutral' },
  }
)

export interface ChipProps
  extends HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof chipVariants> {}

export const Chip = ({ tone, className, ...props }: ChipProps) => (
  <span className={cn(chipVariants({ tone }), className)} {...props} />
)
